import React, { useEffect, useState } from 'react';
import UnitOfferTable from '../unitOffer/UnitOfferTable';
import axios from '../shared/axios';
import { Space, Input, Spin, Row, Col } from 'antd';
import '../Common/Form.css';
import Text from 'antd/lib/typography/Text';

const UnitOffersList = () => {
  const [unitOffers, setUnitOffers] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [status, setStatus] = useState('LOADING');

  useEffect(() => {
    fetchData('current');
  }, []);

  const fetchData = (status) => {
    let AdminURL = `${process.env.REACT_APP_BACKEND_URL}/unit-offers`;
    setStatus('LOADING');
    axios
      .get(AdminURL)
      .then((response) => {
        setUnitOffers((prev) => [...prev, ...response.data.unitOffers]);
        setFilteredTableData((prev) => [...prev, ...response.data.unitOffers]);
        setStatus('SUCCESS');
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
        setStatus('ERROR');
      });
  };

  const textChangeHandler = (e) => {
    let textCode = e.target.value.toUpperCase();
    let filteredData = unitOffers.filter((offer) => {
      if (offer.courseOffer) return offer.courseOffer.code.includes(textCode);
      else return false;
    });
    setFilteredTableData(filteredData);
  };

  const textUnitChangeHandler = (e) => {
    let textCode = e.target.value.toUpperCase();
    let filteredData = unitOffers.filter((offer) => {
      if (offer.unitOfferId)
        return offer.unitOfferId.toString().includes(textCode);
      else return false;
    });
    setFilteredTableData(filteredData);
  };

  if (status === 'LOADING') return <Spin size="large" />;

  if (status === 'ERROR')
    return (
      <Text type="danger">
        Something went wrong, Try Again or Contact Admin.
      </Text>
    );

  return (
    <div>
      <Space size="large">
        <h1>Unit Offers</h1>
      </Space>
      <section className="search-section">
        <Row gutter={16} justify="space-between">
          <Col span={12}>
            <Input
              placeholder="Search by Course Offer..."
              onChange={textChangeHandler}
              type="text"
              id="search-course-offer"
            />
          </Col>
          <Col span={12}>
            <Input
              placeholder="Search by Unit Offer Id..."
              onChange={textUnitChangeHandler}
              type="text"
              id="search-unit-code"
            />
          </Col>
        </Row>
      </section>
      <h3>Total {filteredTableData.length + 1} Record(s)</h3>
      <section>
        <UnitOfferTable data={filteredTableData} />
      </section>
    </div>
  );
};

export default UnitOffersList;
